import * as React from 'react'
import { useDocumentTitle } from '../hooks/useDocumentTitle'
import { omit } from 'lodash'
import { Route, RouteComponentProps } from 'react-router-dom'
import type { ComponentType } from 'react'

interface NewRouteProps {
  path?: string
  exact?: boolean
  strict?: boolean
  component?: ComponentType<any>
  title?: string
}

export interface RouteHandlerDef {
  routes: NewRouteProps[]
  [param: string]: any
}

const DocumentTitle = ({ title }: { title?: string }) => {
  useDocumentTitle(title || '')
  return null
}

const RouteHandler = (props: RouteHandlerDef & React.ClassAttributes<any>) => (
  <div>
    {props.routes.map((route, i) => {
      const parentProps = omit(props, ['children'])

      const routeProps: any = {
        key: i,
        exact: route.exact,
        strict: route.strict,
        path: route.path,
        render: (
          componentProps: RouteComponentProps<
            {
              [x: string]: string | undefined
            },
            unknown,
            unknown
          >
        ) => (
          <React.Fragment>
            <DocumentTitle title={route.title} />
            {route.component ? (
              <route.component {...componentProps} {...parentProps} />
            ) : undefined}
          </React.Fragment>
        )
      }

      return <Route {...routeProps} />
    })}
  </div>
)

export default RouteHandler
